/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDeliverableInvoiceResource } from './';
import {
    ProjectDeliverableInvoiceResourceFromJSON,
    ProjectDeliverableInvoiceResourceFromJSONTyped,
    ProjectDeliverableInvoiceResourceToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';
import type { ProjectDeliverableType } from './';
import {
    ProjectDeliverableTypeFromJSON,
    ProjectDeliverableTypeFromJSONTyped,
    ProjectDeliverableTypeToJSON,
} from './';
import type { ProjectLotDeliverableResource } from './';
import {
    ProjectLotDeliverableResourceFromJSON,
    ProjectLotDeliverableResourceFromJSONTyped,
    ProjectLotDeliverableResourceToJSON,
} from './';
import type { ProjectSingleDeliverableResource } from './';
import {
    ProjectSingleDeliverableResourceFromJSON,
    ProjectSingleDeliverableResourceFromJSONTyped,
    ProjectSingleDeliverableResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDeliverableResource
 */
export interface ProjectDeliverableResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectDeliverableResource
     */
    id: string;
    /**
     * 
     * @type {ProjectDeliverableType}
     * @memberof ProjectDeliverableResource
     */
    type: ProjectDeliverableType;
    /**
     * 
     * @type {ProjectDeliverablePaymentResource}
     * @memberof ProjectDeliverableResource
     */
    payment: ProjectDeliverablePaymentResource;
    /**
     * 
     * @type {Array<ProjectDeliverableInvoiceResource>}
     * @memberof ProjectDeliverableResource
     */
    invoices: Array<ProjectDeliverableInvoiceResource>;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDeliverableResource
     */
    completionDate?: Date;
}

/**
 * Check if a given object implements the ProjectDeliverableResource interface.
 */
export function instanceOfProjectDeliverableResource(value: object): value is ProjectDeliverableResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('payment' in value) || value['payment'] === undefined) return false;
    if (!('invoices' in value) || value['invoices'] === undefined) return false;
    return true;
}

export function ProjectDeliverableResourceFromJSON(json: any): ProjectDeliverableResource {
    return ProjectDeliverableResourceFromJSONTyped(json, false);
}

export function ProjectDeliverableResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDeliverableResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'LOT') {
            return ProjectLotDeliverableResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'SINGLE') {
            return ProjectSingleDeliverableResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'id': json['id'],
        'type': ProjectDeliverableTypeFromJSON(json['type']),
        'payment': ProjectDeliverablePaymentResourceFromJSON(json['payment']),
        'invoices': ((json['invoices'] as Array<any>).map(ProjectDeliverableInvoiceResourceFromJSON)),
        'completionDate': json['completionDate'] == null ? undefined : (new Date(json['completionDate'])),
    };
}

export function ProjectDeliverableResourceToJSON(value?: ProjectDeliverableResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'LOT') {
            return ProjectLotDeliverableResourceToJSON(value as ProjectLotDeliverableResource);
        }
        if (value.type === 'SINGLE') {
            return ProjectSingleDeliverableResourceToJSON(value as ProjectSingleDeliverableResource);
        }
    }
    return {
        
        'id': value['id'],
        'type': ProjectDeliverableTypeToJSON(value['type']),
        'payment': ProjectDeliverablePaymentResourceToJSON(value['payment']),
        'invoices': ((value['invoices'] as Array<any>).map((v) => ProjectDeliverableInvoiceResourceToJSON(v))),
        'completionDate': value['completionDate'] == null ? undefined : ((value['completionDate']).toISOString()),
    };
}

